import * as React from "react";
function SvgSortDownIcon(props: React.SVGProps<SVGSVGElement>) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={8.792} height={14.511} viewBox="0 0 8.792 14.511" {...props}><g transform="translate(-120 -2429.117)"><path d="M14,20l4.4,5.374L22.792,20Z" transform="translate(106 2418.254)" /><path opacity={0.5} d="M14,25.374,18.4,20l4.4,5.374Z" transform="translate(106 2409.117)" /></g></svg>;
}
export default SvgSortDownIcon;